var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import breakpoints from './breakpoints';
import colors from './colors';
import elevation from './elevation';
import getFamilies from './families';
import sizes from './sizes';
import typography from './typography';
import mergeDeep from '../utils/mergeDeep';
var theme = {
    sizes: sizes,
    typography: typography,
    breakpoints: breakpoints,
    colors: colors,
    elevation: elevation,
};
export var createTheme = function (themeOverrides) {
    var updatedTheme = mergeDeep(theme, themeOverrides);
    var mergedFamilies = mergeDeep(getFamilies(updatedTheme.colors), themeOverrides === null || themeOverrides === void 0 ? void 0 : themeOverrides.families);
    return __assign(__assign({}, updatedTheme), { families: mergedFamilies });
};
